// 商品詳細ナビゲーション

class ProductMobileNav extends HTMLElement {
  constructor() {
    super()
    this.adjust = -120
    this.initialize()
  }

  initialize() {
    this.setListeners()
    this.setVisibility(window.scrollY > 10)
  }

  setListeners() {
    window.addEventListener('resize', () => {
      this.setVisibility(window.scrollY > 10)
    })
    window.addEventListener('scroll', () => {
      this.setVisibility(window.scrollY > 10)
    })
  }

  setVisibility(visible) {
    if (visible) {
      this.classList.add('is-active')
    } else {
      this.classList.remove('is-active')
    }
  }
}

;(function () {
  customElements.define('product-mobile-nav', ProductMobileNav)
})()
